/**
 * Algolia Whitelist Constants
 * 
 * These constants define which fields from user publicData are allowed to be saved to Algolia.
 * This whitelist approach ensures only known, safe fields are indexed, preventing accidental
 * exposure of sensitive data.
 */

/**
 * Whitelist of user publicData fields allowed in Algolia User Index
 * These fields are used for user search, filtering, and display in user-related queries
 */
export const ALGOLIA_USER_PUBLIC_DATA_WHITELIST = [
    // Location fields (for display in listing cards)
    'address',
    'city',
    'state',
    'postcode',
    'country',
    'origin',

    // User preferences
    'currency',
    'language',

    // User metrics (for display)
    'rating',
    'reviews',

    'premiumMember',

    // Store information (limited to image, name, and about as per requirements)
    'storeDisplayPhoto',
    'storeName',
    'storeAbout',
    'seoTitle',
    'seoDescription',
    'totalListings',
];

/**
 * Whitelist of user publicData fields allowed in Algolia Listing Index (nested user object)
 * These fields are displayed in listing search results and should be minimal
 */
export const ALGOLIA_LISTING_USER_PUBLIC_DATA_WHITELIST = [
    // Location fields (for display in listing cards)
    'address',
    'city',
    'state',
    'postcode',
    'country',
    'origin',

    // User preferences
    'currency',
    'language',

    // User metrics (for display)
    'rating',
    'reviews',

    // Store information (limited to image, name, and about as per requirements)
    'storeName',
    'storeAbout',
    'totalListings',
    'storeDisplayPhoto',
];

